var $ = require('jquery');
var raf = require('raf');

var easing = 0.125;
var easing = 0.4;
// var easing = 1;
var cursor = $('.cursor').get(0);

var x = -1;
var y = -1;
var target_x = -1;
var target_y = -1;

var mousemoveAnim = function(event){
	var dx = target_x - x;
	var dy = target_y - y;

	x += dx * easing;
	y += dy * easing;

	gsap.set( cursor, {
		x: x,
		y: y
	} )

	raf(mousemoveAnim);
};

var mousemoveEventB = function(event, oevent){
	mousemoveEvent(oevent);
};

var mousemoveEvent = function(event){
	target_x = event.clientX;
	target_y = event.clientY;
	if ( x == -1 ) {
		x = target_x;
		y = target_y;
		mousemoveAnim();
		$('.cursor').addClass('is-active');
	}
	// console.log('mousemoveEvent', mousemoveEvent);
	checkHover();
};

var lastClassAdded = ''; 
var lastClassAddedB = ''; 

var checkHover = function() {
    if (!document.elementsFromPoint) {
        return;
    }

    var currentClassToApply = ''; 
    var currentClassToApplyB = ''; 
    var elements = document.elementsFromPoint(x, y);

    var classPreventingShowingArrows = [
        'projetspost__infos__back__cta',
        'projetspost__infos__credits__cta',
        'projetspost__credits__section',
    ];

    // Boucle for classique pour permettre le break
    for (var i = 0; i < elements.length; i++) {
        var el = elements[i];

        // if el.classList contain on of the class of classPreventingShowingArrows break the loop
        var hasPreventingClass = classPreventingShowingArrows.some(function(className) {
            return el.classList.contains(className);
        });

        if (el.classList.contains('showcase__cta__retour__label')) {
            currentClassToApply = '';
            break;
        }

        if (hasPreventingClass) {
            break;
        }
        
        // On utilise classList (natif) pour la performance dans la boucle
        if (el.classList.contains('projetspost__visuels__group__groupes__items__arrow')) {
            if (el.classList.contains('prev')) {
                currentClassToApply = 'is-hover-projetslide-item-left';
            } else if (el.classList.contains('next')) {
                currentClassToApply = 'is-hover-projetslide-item-right';
            }
            
            // On a trouvé l'élément cible, on stoppe la recherche dans les parents
            break; 
        }

        // Sécurité pour annuler le hover sur des zones spécifiques
        // if (el.classList.contains('films__video__detail__video')) {
        //     break; 
        // }
    }

    $('.projetspost__visuels__group__groupes__items__nav__visu')
        .removeClass('is-hover')

    for (var i = 0; i < elements.length; i++) {
        var el = elements[i];
        if (el.classList.contains('projetspost__visuels__group__groupes__visuels__item__inner')) {
            $('.projetspost__visuels__group__groupes__items__nbs.v3 .projetspost__visuels__group__groupes__items__nb').html($(el).attr('data-image-count'))
        	currentClassToApplyB = 'is-hover-image';
            $('.projetspost__visuels__group__groupes__items__nav__visu')
                .eq(Number($(el).attr('data-image-index')))
                .addClass('is-hover')
        	break;
        }
    }

    // --- MISE À JOUR DU DOM (Seulement si changement d'état) ---
    if (currentClassToApply !== lastClassAdded) {
        // Suppression de l'ancienne classe
        if (lastClassAdded !== '') {
            $('body').removeClass(lastClassAdded);
        }

        // Ajout de la nouvelle classe
        if (currentClassToApply !== '') {
            $('body').addClass(currentClassToApply);
        } 

        // Enregistrement de l'état pour le prochain event
        lastClassAdded = currentClassToApply;
    }
        

    if (currentClassToApplyB !== lastClassAddedB) {
        // Suppression de l'ancienne classe
        if (lastClassAddedB !== '') {
            $('body').removeClass(lastClassAddedB);
        }

        // Ajout de la nouvelle classe
        if (currentClassToApplyB !== '') {
            $('body').addClass(currentClassToApplyB);
        } 

        // Enregistrement de l'état pour le prochain event
        lastClassAddedB = currentClassToApplyB;
    }
        
};

// if ( $('body').hasClass('is-desktop') ) {
	$('body').on('mousemove', mousemoveEvent);
	$(window).on('scroll', checkHover);
	$(window).on("flickity:dragMove", mousemoveEventB);
// }

// $(window).on('site:initPage', function(evt, el){
// 	$(el).find('.home__news__item ').hover(function(){
// 		$('body').addClass('is-hover-projet-item');
// 	}, function(){
// 		$('body').removeClass('is-hover-projet-item');
// 	});
// });
